import React from "react";
import { routes } from "../../../constants";
import { Navigate, Route, Routes } from "react-router-dom";
import { baseRouteMakerForSuperAdmin } from "../../../constants/routeConsts";
import AuthLayout from "../../../component/common/layouts/auth/AuthLayout";
import MainLayout from "../../../component/common/layouts/main/MainLayout";
import userLayouts from "../../../constants/userLayoutsConsts";
import renderProtectedRoutes from "./renderProtectedRoutes";
import { SignIn, SignUp } from "../../../component/pages/service-provider-admin";

const renderSuperAdminRoutes = () => {
  return (
    <>
      <Routes>
        <Route path={routes.DEFAULT_BASE_REDIRECT} element={ <Navigate to={baseRouteMakerForSuperAdmin(routes.SIGN_IN)} replace/>}/>

        {/* public routes */}
        <Route element={<AuthLayout />}>
          <Route path={routes.SIGN_IN} element={<SignIn />} />
          <Route path={routes.SIGN_UP} element={<SignUp />} />
        </Route>
        {/* public routes */}

        {/* protected routes */}
        <Route path="/" element={<MainLayout />}>
          {renderProtectedRoutes(userLayouts.IS_MAIN)}
        </Route>
        {/* protected routes */}
      </Routes>
    </>
  );
};

export default renderSuperAdminRoutes;
